.container > * {
    margin-bottom: 16px;
}

.container > .input-button {
    background-color: white;
}

.email-container {
    display: flex;
}

.bold-text {
    font-weight: 500;
}
